import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';

// Cascade 순서 중요:
//   tokens.css  (SSOT 색상 변수 선언)
//   tailwind.css (utilities — var(--*) 참조)
//   global.css  (body/html 리셋 — semantic 변수만 사용)
import './styles/tokens.css';
import './components/shapes/shapes.css';
import './styles/tailwind.css';
import './styles/global.css';
import './styles/confirm-dialog.css';
import './styles/language-switcher.css';

import { LanguageProvider } from './features/i18n';
import { queryClient } from './lib/queryClient';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root 엘리먼트를 찾을 수 없습니다. index.html 확인.');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </QueryClientProvider>
  </StrictMode>,
);
